// @ts-expect-error untyped module
import { getIsUngatedForInAppGoogleYahooAlerts } from 'EmailData/selectors/user';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import { useSelector } from 'react-redux';
import ToolDescription from './ToolDescription';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function AffectedEmailsDropdownItem() {
  const isUngatedForInAppGoogleYahooAlerts = useSelector(getIsUngatedForInAppGoogleYahooAlerts);
  if (!isUngatedForInAppGoogleYahooAlerts) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsxs(UIButton, {
      href: `/email/${PortalIdParser.get()}/manage/affected-emails`,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "EmailComponents.manage.moreTools.affectedEmails"
      }), /*#__PURE__*/_jsx(ToolDescription, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.manage.moreTools.affectedEmailsDescription"
        })
      })]
    })]
  });
}